import React from "react";
import { FaQuestionCircle } from "react-icons/fa";
import { Tooltip } from "react-tooltip";

/**
 * Reusable help icon with tooltip. Use a unique id per field to avoid conflicts.
 * @param {string} tooltipId - Unique id for the tooltip (e.g. "custom-line-item-location-help")
 * @param {React.ReactNode|string} content - Tooltip content (JSX or string)
 */
function FieldHelpIcon({ tooltipId, content }) {
  const contentNode = typeof content === "string" ? <span className="text-left text-xs text-white block max-w-xs p-1">{content}</span> : content;
  return (
    <>
      <a data-tooltip-id={tooltipId} className="inline-flex ml-1 cursor-pointer focus:outline-none" aria-label="Field help">
        <FaQuestionCircle className="text-gray-400 hover:text-gray-500 text-sm" />
      </a>
      <Tooltip
        id={tooltipId}
        place="top"
        variant="dark"
        className="z-[100]"
        render={() => contentNode}
      />
    </>
  );
}

export default FieldHelpIcon;
